import { initialState, ServicesState, servicesAdapter } from './services.interfaces';
import * as fromServices from './services.actions';
import { MetaReducer, ActionReducer } from '@ngrx/store';

export function reducer(state: ServicesState, action: fromServices.ServicesAction): ServicesState {
  switch (action.type) {
    case fromServices.GET_SERVICES_FROM_SERVER_SUCCESS: {
      return {
        ...servicesAdapter.addMany(action.payload.services, state)
      };
    }

    default: {
      return state;
    }
  }
}

export function servicesStateHydration(reducer: ActionReducer<ServicesState>): ActionReducer<ServicesState> {
  return function(state: ServicesState, action: any, metaReducer: string = 'stateHydration'): ServicesState {
    //console.log('SERVICE GROUPS');
    if (state === undefined) {
      console.log('populate services state from local storage?');
      let serviceGroups: any = localStorage.getItem('services-state');
      state = serviceGroups ? JSON.parse(serviceGroups) : initialState;
    }
    const newState = reducer(state, action);
    // if (action.feature === 'labourOperations.services' && action.triggerStorageSync) {
    //   localStorage.setItem('services-state', JSON.stringify(newState));
    // }

    return newState;
  };
}

export const metaReducers: MetaReducer<ServicesState>[] = [servicesStateHydration];
